// extracted by mini-css-extract-plugin
export default {"Hero":"CommonHero_Hero__+ixnf","Hero_Cont":"CommonHero_Hero_Cont__aEdjQ","Hero_Content":"CommonHero_Hero_Content__DTUIX"};